import {
  breakpoints,
  Button,
  DropdownMenu,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDropdownMenu = styled(DropdownMenu)`
  ${DropdownMenu.Styled.DropdownContent} {
    gap: 0;
  }

  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledButton = styled(Button)`
  margin-top: 1px;
`;

export const StyledXsButton = styled(Button)`
  margin-left: 36px;
  width: 209px;
`;
